import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import { API_URL } from './config'

// Configure axios
axios.defaults.baseURL = API_URL

// Add Authorization header to requests if token exists
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle response errors
axios.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

// Create the app instance
const app = createApp(App)

// Set up Pinia store
app.use(createPinia())

// Set up router
app.use(router)

// Mount the app
app.mount('#app')
